import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=6453ddd7&scoped=true&"
import script from "./logList.vue?vue&type=script&lang=js&"
export * from "./logList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453ddd7",
  null
  
)

export default component.exports